export default __webpack_public_path__ + "static/media/book-nav-icon5.20490f2c.svg";